const seguridadDAModulo = {
    agGrid: {
        paginacion: 15,
        id: 'myGrid',
        class: 'ag-theme-alpine mt-3',
        style: {
            width: '100%',
            height: '600px'
        }
    },
    agGridModal: {
        paginacion: 10,
        id: 'myGrid',
        class: 'ag-theme-alpine mt-3',
        style: {
            width: '100%',
            height: '450px'
        }
    },
    url: {
        seguridad: {
            aplicacion: 'aplication',
            tipoAplicacion: 'tipo_app',
            aplicacionUser: 'aplication_user',
        },
        onlyControl: {
            updateFoto: 'syncDA/updateFoto/',
            syncPhotoStatus: 'syncPhotoStatus'
        }
    },
    button: {
        buttonsCss: {
            primary: 'btn btn-primary btn-block',
            secondary: 'btn btn-secondary btn-block',
            success: 'btn btn-success btn-block',
            danger: 'btn btn-danger btn-block',
            warning: 'btn btn-warning btn-block',
            info: 'btn btn-info btn-block',
            light: 'btn btn-light btn-block',
            dark: 'btn btn-dark btn-block',
            primaryOutline: 'btn btn-outline-primary',
            secondaryOutline: 'btn btn-outline-secondary',
            successOutline: 'btn btn-outline-success',
            dangerOutline: 'btn btn-outline-danger',
            warningOutline: 'btn btn-outline-warning',
            infoOutline: 'btn btn-outline-info',
            lightOutline: 'btn btn-outline-light',
            darkOutline: 'btn btn-outline-dark',
            primarylg: 'btn btn-primary btn-lg btn-block',
            successLg: 'btn btn-success btn-lg btn-block',
            dangerLg: 'btn btn-danger btn-lg btn-block',
            warningLg: 'btn btn-warning btn-lg btn-block',
            warningLgFile: 'btn btn-warning btn-lg btn-block btn-file',
        },
        buttonsNombre: {
            editar: 'Editar',
            ver: 'Ver',
            eliminar: 'Eliminar',
            agregar: 'Agregar ',
            guardar: 'Guardar',
            actualizar: 'Actualizar',
            mostrar: 'Mostrar seleccion',
            regresar: 'Regresar',
            continuar: 'Continuar',
            seleccionar: 'Seleccionar',
            procesar: 'Procesar',
            buscar: 'Buscar',
            sustento: 'Sustento',
            validar: 'Validar',
            descargar: 'Descargar',
        }
    },
    mensajes: {
        errorServicio: 'error..!!',
        desabilitada: 'Opción desabilitada',
        eliminar: '¿Esta seguro que desea eliminar el siguiente elemento?',
        guardar: '¿Esta seguro que desea guardar?',
        actualizar: '¿Esta seguro que desea actualizar el siguiente elemento?',
        datoGuardado: 'Se guardo corectamente..!!',
        guardarParada: 'Esta seguro que desea registrar este evento..??',
        procesar: '¿Esta seguro que desea procesar el siguiente elemento?',
        validar: '¿Esta seguro que desea validar el siguiente elemento?',
        anular: 'Confirma que desea eliminar el registro seleccionado.',
    },
    colors: {
        verde: 'green',
        azul: 'blue',
        rojo: 'red'
    },
    div: {
        resposiveFull: 'col-12 col-sm-6 col-md-6 col-lg-4 ',//verificar el tipo de pantalla
    }
}

export { seguridadDAModulo }
